import React from 'react';
import OrderSummaryContent from './OrderSummaryContent';

/**
 * Fixed right sidebar for Order Summary (desktop only)
 */
const OrderSummarySidebar = ({
    ordersByDeliveryDate,
    deliveryDates,
    billingChanges,
    customerToken,
    pendingChanges,
    priorPaymentsByDate,
    paymentRecords,
    onSaveSuccess,
    customerDetails
}) => {
    return (
        <aside className="order-sidebar">
            <OrderSummaryContent
                ordersByDeliveryDate={ordersByDeliveryDate}
                deliveryDates={deliveryDates}
                billingChanges={billingChanges}
                customerToken={customerToken}
                customerName={customerDetails?.customer?.name || ''}
                pendingChanges={pendingChanges}
                priorPaymentsByDate={priorPaymentsByDate}
                paymentRecords={paymentRecords}
                onSaveSuccess={onSaveSuccess}
                variant="sidebar"
                customerDetails={customerDetails}
            />
        </aside>
    );
};

export default OrderSummarySidebar;
